import axios from "../utils/axiosConfig";

const authorService = {
    getAll: async (params = {}) => {
        try {
            const response = await axios.get("/authors", { params });
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    getById: async (id) => {
        try {
          const response = await axios.get(`/authors/${id}`);
          return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },

    create: async (data) => {
        return axios.post("/authors", data);
    },

    update: async (id, data) => {
        return axios.put(`/authors/${id}`, data);
    },

    delete: async (id) => {
        return axios.delete(`/authors/${id}`);
    },
};

export default authorService;
